module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Stop-3089db1f6bfb89547d2c28985afba35eeb62c63b3dfde8ffac4d9c1c438663af.svg";